import {
  NavBar,
  Search,
  Icon,
  Button,
  Toast,
  DatetimePicker,
  Popup,
  Picker,
  RadioGroup,
  Radio,
  SubmitBar,
  Image as VanImage,
  Notify,
  Uploader,
  Empty,
  Dialog,
  Badge,
  List,
  Tag,
} from 'vant'

const templateList = [
  NavBar,
  Search,
  Icon,
  Button,
  Toast,
  DatetimePicker,
  Popup,
  Picker,
  RadioGroup,
  Radio,
  SubmitBar,
  VanImage,
  Notify,
  Uploader,
  Empty,
  Dialog,
  Badge,
  List,
  Tag,
]

export default templateList
